// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"HeaderDark_headerContainer__3gxio","switch":"HeaderDark_switch__2TNrY","slider":"HeaderDark_slider__31zFe","sliderRound":"HeaderDark_sliderRound__3tq7G"};